<ht-modal [options]="modalOptions" #modal>
  Our customer team will contact you to upgrade your license limit.
</ht-modal>
